import { TReply } from '../../../types/messages';
import { TThumbnail } from '../../../types/thumbnail';
import { getFileSrc } from '../../../utils/getFileSrc';

interface IGetReplyQuoteContentResult {
  text: string;
  thumbnail: TThumbnail;
}

export const getReplyQuoteContent = (reply: TReply, chatId: string): IGetReplyQuoteContentResult => {
  switch (reply.type) {
    case 'photo':
      return {
        text: reply.quoteText || 'Фотография',
        thumbnail: { type: 'image', url: getFileSrc(reply.quoteFileUid, chatId) },
      };
    case 'offer':
      return {
        text: reply.quoteText,
        thumbnail: reply.quoteImageUrl ? { type: 'image', url: reply.quoteImageUrl } : null,
      };
    case 'document':
      return {
        text: reply.quoteText,
        thumbnail: { type: 'document' },
      };
    case 'text':
    case 'deleted':
    default:
      return { text: reply.quoteText, thumbnail: null };
  }
};
